import Layout from "Layout"
import StripePaymentForm from "./StripeCheckoutButton"
import { useEffect, useState } from "react"

const PaymentByCard = () => {
    const [getClientSecret, setGetClientSecret] = useState<string>('')
    const [getOrderId, setGetOrderId] = useState<string>('')
    const [getEmailUser, setGetEmailUser] = useState<string>('')

    useEffect(() => {
        const userData = localStorage.getItem('user')
        const key = localStorage.getItem('clientSecret')
        const id = localStorage.getItem('orderId')

        if (userData && key && id) {
            const email = JSON.parse(userData).email

            setGetClientSecret(key)
            setGetEmailUser(email)
            setGetOrderId(id)
        }
    }, [])

    return (
        <Layout>
            <StripePaymentForm clientSecret={getClientSecret} orderId={getOrderId} email={getEmailUser} />
        </Layout>
    )
}

export default PaymentByCard